import { gql } from "@apollo/client";
import { GenericRow } from "../../../../Components/Tables/_Tables/useColumnConstructor";

export const SKIP_FEED = gql`
  mutation SkipFeed($domain: String!, $locationid: Int!, $amount: Int!) {
    location {
      skipFeed(domain: $domain, locationid: $locationid, amount: $amount) {
        code
        success
        message
      }
    }
  }
`;

export interface SkipFeed {
  domain: string
  locationid: number
  amount: number
}

export interface BaseFeedSkipMutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export interface SkipFeedMutationResponse {
  location: {
    skipFeed: BaseFeedSkipMutationResponse
  }
}